/**
 * @description 词tag
 * @author duanjun
 */

import { dpr } from './util';
interface IOptions {
    fontSize: number;
    color: string;
    fontFamily?: string;
    fontWeight: string | number;
    padding?: number;
    text: string;
}

export default class Tag {
    public width: number = 0;
    public height: number = 0;
    public fontSize: number;
    public canvas: HTMLCanvasElement;
    public x: number = 0;
    public y: number = 0;
    private text: string;
    private fontFamily: string;
    private color: string;
    private fontWeight: string | number;
    private padding: number;
    private context: CanvasRenderingContext2D;

    constructor(options: IOptions) {
        const { fontSize, color, fontFamily, text, padding, fontWeight} = options;
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;
        this.fontSize = Math.round((fontSize || 15) * dpr);
        this.color = color || '#ff0000';
        this.fontFamily = fontFamily || '';
        this.fontWeight = fontWeight;
        this.text = text || '';
        this.padding = Math.round((padding || 4) * dpr);
        this.resize();
        this.draw();
    }

    public area() {
        return this.canvas.width * this.canvas.height;
    }

    public draw() {
        const context = this.context;
        context.save();
        this.setStyle();
        context.fillText(this.text, this.padding, this.padding);
        context.restore();
    }

    public setStyle() {
        const context = this.context;
        context.font = `${this.fontWeight} ${this.fontSize}px ${this.fontFamily || 'Arial'}`;
        context.textBaseline = 'top';
        context.fillStyle = this.color;
    }

    public resize() {
        this.setStyle();
        this.canvas.width = this.width = this.context.measureText(this.text).width + this.padding * 2;
        this.canvas.height = this.height = this.fontSize + this.padding * 2;
    }

    public updatePosition(x: number, y: number) {
        this.x = x;
        this.y = y;
    }


    public getLines() {
        const halfWidth = Math.round(this.width / 2);
        const halfHeight = Math.round(this.height / 2);
        return {
            startX: this.x - halfWidth,
            endX: this.x + halfWidth,
            startY: this.y - halfHeight,
            endY: this.y + halfHeight,
        };
    }

    /**
     * @description 顶点坐标, 纹理点，为了提升性能，也为了判断更准备，做了一些点的省略
     * 1 - 2 - 3 - 4
     * 5 - 6 - 7 - 8
     */
    public getTexturePoints() {
        const lines = this.getLines();
        const step = 4;
        const points = [];
        for (let y = lines.startY + 4; y < lines.endY; y += step) {
            for (let x = lines.startX + 4; x < lines.endX; x += step) {
                points.push({ x, y });
            }
        }
        return points;
    }

    /**
     * @description 顶点坐标, 顺时针
     * 1 - 2
     * |   |
     * 3 - 4
     */
    public getVertexPoints() {
        const lines = this.getLines();
        return [
            {
                x: lines.startX,
                y: lines.startY,
            },
            {
                x: lines.endX,
                y: lines.startY,
            },
            {
                x: lines.endX,
                y: lines.endY,
            },
            {
                x: lines.startX,
                y: lines.endY,
            },
        ];
    }
}
